export class ContentInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get content() {
        return this.parent;
    }
    get contentIndex() {
        return this.content.aspect.aspectContent.local.contentTraits.indexOf(this.content.trait);
    }
    get contentNumber() {
        return this.contentIndex + 1;
    }
}
